import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const WarningModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Warning</DialogTitle>
      <DialogContent>
        Be cautious when dealing with agencies as they are not verified by Proparty.website!!!
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningModal;
